import { useState } from "react";
import PropTypes from "prop-types";

import { formatDate, getFirstMiddleName } from "@gyandiksha/shared-ui";

import FamilySocialInfo from "./FamilySocialInfo";
import CurrentAcademicInfo from "./CurrentAcademicInfo";
import AcademicHistoryInfo from "./AcademicHistoryInfo";
import SocialMediaCard from "../components/common/SocialMediaCard";
import ProfilePhotoAvatar from "./ProfilePhotoAvatar";

import { MASKEDTYPE, MaskedValue } from "@repo/design-system/components/ui";

const ProfileMainContent = ({
  profileData,
  socialNetwork,
  onRefetchDashboard,
  onAddSocial,
  onEditSocial,
  onDeleteSocial,
  onFetchSocialById,
  isSavingSocial,
  isDeletingSocial,
}) => {

  const [expandedSections, setExpandedSections] = useState({
    currentAcademic: true,
    academicHistory: false,
    familySocial: false,
  });

  const toggleSection = (key) =>
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));

  const basic = profileData?.basicDetailsInfoDTO || {};
  const fullName = getFirstMiddleName(basic.fullName, basic.firstName, basic.lastName) || "-";

  return (
    <div className="sp-content row">
      {/* Left Panel Column */}
      <div className="col-md-5 col-xl-4">
        <div className="sp-left-panel">
          <ProfilePhotoAvatar fullName={fullName} fallbackSrc={profileData?.avatarUrl} />

          <h2 className="sp-name">{fullName}</h2>
          <div className="sp-details mt-3">
            <div className="sp-detail-row align-items-center justify-content-center">
              <span className="sp-detail-label">APAAR / ABC ID :</span>
              <span className="sp-detail-value">
                <MaskedValue value={basic.apaarId} targetId="apparId-view" />
              </span>
            </div>
            <div className="sp-divider" />

            <div className="sp-detail-row">
              <span className="sp-detail-label">Mobile No. :</span>
              <span className="sp-detail-value">
                <MaskedValue value={basic?.contact}
                  maskedType={MASKEDTYPE.PHONE}
                  targetId="contact-view" />
              </span>
            </div>
            <div className="sp-detail-row">
              <span className="sp-detail-label">Email Address :</span>
              <span className="sp-detail-value">
                <MaskedValue value={basic.email}
                  maskedType={MASKEDTYPE.EMAIL}
                  targetId="emailaddress-view" />
              </span>
            </div>
            <div className="sp-detail-row">
              <span className="sp-detail-label">Date Of Birth :</span>
              <span className="sp-detail-value">
                {basic.dob ? formatDate(basic.dob, "DD/MM/YYYY") : "-"}
              </span>
            </div>
            <div className="sp-detail-row">
              <span className="sp-detail-label">Gender :</span>
              <span className="sp-detail-value">{basic.gender || "-"}</span>
            </div>
            <div className="sp-detail-row">
              <span className="sp-detail-label">Student Category :</span>
              <span className="sp-detail-value">{profileData?.currentAcademicInformation?.categoryName || "-"}</span>
            </div>
            <div className="sp-detail-row">
              <span className="sp-detail-label">Religion :</span>
              <span className="sp-detail-value">{basic.religion || "-"}</span>
            </div>
            <div className="sp-detail-row">
              <span className="sp-detail-label">Are you a Non-Gujarat Domicile? :</span>
              <span className="sp-detail-value">{basic.domicileState ? "Yes" : "No"}</span>
            </div>
            {basic.domicileState && (
              <div className="sp-detail-row">
                <span className="sp-detail-label">Domicile State :</span>
                <span className="sp-detail-value">{basic.domicileState || "-"}</span>
              </div>
            )}
            <div className="sp-detail-row">
              <span className="sp-detail-label">Person with Disability (PWD)? :</span>
              <span className="sp-detail-value">{basic.pwd ? "Yes" : "No"}</span>
            </div>
          </div>
        </div>

        {/* Social Media Card (Outside of sp-left-panel card) */}
        <div className="mt-3">
          <SocialMediaCard
            socialNetwork={socialNetwork || profileData?.socialNetwork || basic?.socialNetwork || []}
            onAdd={onAddSocial}
            onEdit={onEditSocial}
            onDelete={onDeleteSocial}
            onFetchById={onFetchSocialById}
            isSaving={isSavingSocial}
            isDeleting={isDeletingSocial}
          />
        </div>
      </div>

      {/* Right Panel — distinct subcomponents */}
      <div className="sp-right-panel col-md-7 col-xl-8">
        <CurrentAcademicInfo
          currentAcademicInfo={profileData?.currentAcademicInformation}
          isOpen={expandedSections.currentAcademic}
          onToggle={() => toggleSection("currentAcademic")}
        />

        <AcademicHistoryInfo
          academicHistory={profileData?.academicHistory}
          isOpen={expandedSections.academicHistory}
          onToggle={() => toggleSection("academicHistory")}
          onRefetchDashboard={onRefetchDashboard}
        />

        <FamilySocialInfo
          basic={basic}
          isOpen={expandedSections.familySocial}
          onToggle={() => toggleSection("familySocial")}
        />
      </div>
    </div>
  );
};

ProfileMainContent.propTypes = {
  profileData: PropTypes.object,
  onRefetchDashboard: PropTypes.func,
};

export default ProfileMainContent;
